import { Box, CircularProgress } from "@mui/material";
import { useMainStyles } from "../MillLocalserverMetrics.styles";
import { useStyles } from "./StatusReportsTableDetails.styles";
import { MainTable } from "components";
import { useStatusReportsColumns } from "./hook/useStatusReportsColumns";
import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import { MillNetworkDetailsContext } from "contexts/MillNetworkDetailsContext/MillNetworkDetailsContext";
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import NoData from "components/NoData/NoData.view";
import { LocalserverStatusTableColumnsIdEnum } from "./StatusReportsTableDetailsInterfaces";

export const StatusReportsTableDetails = () => {
    const classes = useStyles();
    const mainClasses = useMainStyles();
    const { t } = useTranslation();

    const { statusReports, loading, statusAverages, statusReportsTableResources } =
        useContext(MillNetworkDetailsContext);

    const tableColumns = useStatusReportsColumns() as IMainTableColumn[];

    const bodyComponent = useMemo(() => {
        const { order, orderBy, page, rowsPerPage, handleRequestSort, handleChangeRowsPerPage, handleChangePage } =
            statusReportsTableResources;

        if (loading) {
            return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CircularProgress color="info" size={20} />
                </Box>
            );
        }
        if (statusReports.length === 0) {
            return (
                <Box className={classes.noData}>
                    <NoData title={t("locations.mill_network_details.no_disconnections")} />
                </Box>
            );
        }
        return (
            <MainTable
                columns={tableColumns}
                rows={statusReports}
                loading={loading}
                pagination
                count={statusAverages?.total_occurrences}
                tableOperationsValues={{ order, orderBy, page, rowsPerPage }}
                handleRequestSortParent={handleRequestSort}
                handleChangeRowsPerPageParent={handleChangeRowsPerPage}
                handleChangePageParent={handleChangePage}
                querySorted={orderBy !== LocalserverStatusTableColumnsIdEnum.DURATION}
            />
        );
    }, [
        t,
        statusReports,
        loading,
        classes,
        tableColumns,
        statusReportsTableResources,
        statusAverages?.total_occurrences,
    ]);

    return (
        <Box className={classes.detailsBox}>
            <div className={mainClasses.card}>
                <div className={mainClasses.mainWrapperHeaderTitle}>
                    {t("locations.mill_network_details.log_table_title")}
                </div>
                <div className={mainClasses.cardBody}>{bodyComponent}</div>
            </div>
        </Box>
    );
};
